module.exports = __webpack_public_path__ + "img/jugando.aa779318.png";